import angular from 'angular';
import ngResource from 'angular-resource';
import './lb-services';
import LoginService from './login.service';
import ClientsService from './clients.service';
import UsersService from './users.service';
import EmployeesService from './employees.service';
import BankTxesService from './banktxes.service';
import CollectionsService from './collections.service';
import ReceiptsService from './receipts.service';
import ChecksService from './checks.service';
import ProceduresService from './procedures.service';
import OrderTranslationService from './order-translation.service';
import StorageService from './storage.service';
import ProcedureTemplatesService from './procedure-templates.service';
import ItemTemplatesService from './item-templates.service';
import VehiclesService from './vehicles.service';
import QuotesService from './quotes.service';
import ItemsService from './items.service';
import SpendingsService from './spendings.service';
import OperativeSpendingsService from './operative-spendings.service';
import SpendingTypesService from './spending-types.service';
import VouchersService from './vouchers.service';
import WorkersService from './workers.service';
import PendingSpendingsService from './pendingspendings.service';
import CashboxesService from './cashboxes.service';
import RegistriesService from './registries.service';
import GroupInvoicesService from './group-invoices.service';
import CashboxTransfersService from './cashbox-transfers.service';
import StatesTemplatesService from './states-template.service';
import OperationProceduresService from './operation-procedures.service';
import BrandsService from './brands.service';
import CreditorsService from './creditors.service';
import AgenciesService from './agencies.service';
import SalesmenService from './salesmen.service';
import OperationTypesService from './operation-types.service';
import OperationsService from './operations.service';
import OPHistoriesService from './operation-procedure-histories.service';
import OperationTasksService from './operation-tasks.service';
import ProvincesService from './provinces.service';
import CitiesService from './cities.service';
import OCommentsService from './operation-comments.service';
import AssignationsService from './assignations.service';
import FleetsService from './fleets.service';
import CronologiesService from './cronologies.service';
import TasksService from './tasks.service';

const servicesModule = angular
  .module('app.services', [ngResource, 'lbServices'])
  .service('LoginService', LoginService)
  .service('ClientsService', ClientsService)
  .service('UsersService', UsersService)
  .service('EmployeesService', EmployeesService)
  .service('BankTxesService', BankTxesService)
  .service('CollectionsService', CollectionsService)
  .service('ReceiptsService', ReceiptsService)
  .service('ChecksService', ChecksService)
  .service('ProceduresService', ProceduresService)
  .service('OrderTranslationService', OrderTranslationService)
  .service('StorageService', StorageService)
  .service('ProcedureTemplatesService', ProcedureTemplatesService)
  .service('ItemTemplatesService', ItemTemplatesService)
  .service('VehiclesService', VehiclesService)
  .service('QuotesService', QuotesService)
  .service('ItemsService', ItemsService)
  .service('SpendingsService', SpendingsService)
  .service('OperativeSpendingsService', OperativeSpendingsService)
  .service('SpendingTypesService', SpendingTypesService)
  .service('VouchersService', VouchersService)
  .service('WorkersService', WorkersService)
  .service('PendingSpendingsService', PendingSpendingsService)
  .service('CashboxesService', CashboxesService)
  .service('RegistriesService', RegistriesService)
  .service('GroupInvoicesService', GroupInvoicesService)
  .service('CashboxTransfersService', CashboxTransfersService)
  .service('StatesTemplatesService', StatesTemplatesService)
  .service('OperationProceduresService', OperationProceduresService)
  .service('BrandsService', BrandsService)
  .service('CreditorsService', CreditorsService)
  .service('AgenciesService', AgenciesService)
  .service('SalesmenService', SalesmenService)
  .service('OperationTypesService', OperationTypesService)
  .service('OperationsService', OperationsService)
  .service('OPHistoriesService', OPHistoriesService)
  .service('OperationTasksService', OperationTasksService)
  .service('CitiesService', CitiesService)
  .service('ProvincesService', ProvincesService)
  .service('OCommentsService', OCommentsService)
  .service('AssignationsService', AssignationsService)
  .service('FleetsService', FleetsService)
      .service('CronologiesService', CronologiesService)
      .service('TasksService', TasksService)
      .name;

export default servicesModule;
